import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

const VEHICLE_RESOURCE = "vehicle" as const;
export const VEHICLE_VALUATION_RESET_CONFIRMATION_AND_ASSIGNMENT_OPERATION =
  "reset-confirmation-and-assignment" as const;
export const VEHICLE_VALUATION_RESET_CONFIRMATION_AND_ASSIGNMENT_API_PATH =
  `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/${VEHICLE_VALUATION_RESET_CONFIRMATION_AND_ASSIGNMENT_OPERATION}` as const;

export type VehicleValuationResetConfirmationAndAssignmentResponse =
  paths[typeof VEHICLE_VALUATION_RESET_CONFIRMATION_AND_ASSIGNMENT_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useVehicleValuationResetConfirmationAndAssignmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationResetConfirmationAndAssignmentResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<VehicleValuationResetConfirmationAndAssignmentResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}/${VEHICLE_VALUATION_RESET_CONFIRMATION_AND_ASSIGNMENT_OPERATION}`,
      );

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
        }),
      ]);
    },
  });
};
